import { DragDropScreenActionTypes, DragDropScreenTypes } from "./dragDropScreenTypes";

export function changeDragDropScreen(data: boolean): DragDropScreenActionTypes {
	return {
		type: DragDropScreenTypes.UPDATE_DRAGGING,
		payload: { data },
	};
}

export function resetReducerDragDropScreen(): DragDropScreenActionTypes {
	return {
		type: DragDropScreenTypes.RESET_DRAG_DROP,
	};
}
